<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true">
    </loading>
    <!-- <FORM NAME="FROM1" ACTION="https://testtrustlink.hitrust.com.tw/TrustLink/TrxReqForJava" METHOD="POST" > -->
    <FORM NAME="FROM1" ACTION="https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT/TrustLink/TrxReqForJava" METHOD="POST" >
	
    <v-row class="text-left search-bar">
      <v-col class="pt-4 pl-0 col-9 col-md-8">
        <v-tabs class="ml-6 tabsLeft" color="#215DA7" v-model="tab">
          <v-tabs-slider color="#215DA7" style="left:0"></v-tabs-slider>
          <v-tab><span style="font-size:15pt; font-weight:550">場次資訊</span></v-tab>
          <v-tab><span style="font-size:15pt; font-weight:550">報名及成績一覽表</span> </v-tab>
          <v-tab v-show="datasets.payGroup == '1'"><span style="font-size:15pt; font-weight:550">前往繳費</span></v-tab>
          <v-tab v-show="examTimeNow"><span style="font-size:15pt; font-weight:550">各式申請總表</span></v-tab>
        </v-tabs>
      </v-col>

      <v-col v-show="tab==0" class="py-3 text-right pr-10 col-3 col-md-4">
        <!-- APP -->
        <div>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="appBtn" style="display: none">
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
              <v-btn icon v-bind="attrs" v-on="on" class="webBtn" style="width:160px; border-radius:8px; color:#FFFFFF">
                <span class="px-2 menuAppBtn">功能選單</span>
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list style="width: 200px;cursor: pointer">
              <v-list-item @click="duplication()">
                <v-list-item-title>
                  <span>複製場次設定</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="$refs.ShowMsg.open(2)">
                <v-list-item-title>
                  <span>修改場次資訊</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="datasets.payGroup=='2' && receiptDownload" @click="getReceiptPdf()">
                <v-list-item-title>
                  <span>下載收據</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>

      <v-col v-show="tab==1" class="py-3 text-right pr-10 col-3 col-md-4">
        <!-- APP -->
        <div>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="appBtn" style="display: none">
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
              <v-btn icon v-bind="attrs" v-on="on" class="webBtn" style="width:160px; border-radius:8px; color:#FFFFFF">
                <span class="px-2 menuAppBtn">功能選單</span>
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list style="width: 230px;cursor: pointer">
              <v-list-item v-if="datasets.applyStatus != '2'" @click="$refs.DeleteConfirm.open(1,'','',true); deleteId = -1">
                <v-list-item-title>
                  <span>批次刪除</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="getDatasetExcel()">
                <v-list-item-title>
                  <span>下載場次資訊（含成績）</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="datasets.certificatePrintCount=='2'" @click="getCertificatePdf()">
                <v-list-item-title>
                  <span>下載證書</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>

      <v-col v-show="tab==3" class="py-3 text-right pr-10 col-3 col-md-4">
        <!-- APP -->
        <div>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="appBtn" style="display: none">
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
              <v-btn icon v-bind="attrs" v-on="on" class="webBtn" style="width:160px; border-radius:8px; color:#FFFFFF">
                <span class="px-2 menuAppBtn">功能選單</span>
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list style="width: 200px;cursor: pointer">
              <v-list-item @click="redirectPath('/applyCertificate', -1)">
                <v-list-item-title>
                  <span>前往各式申請</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="receiptAppendDownload" @click="getReceiptAppendPdf()">
                <v-list-item-title>
                  <span>下載紙本證書收據</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>
    </v-row>
    
    <div v-show="tab==0" id="router" :style="viewStyle">
      <div id="box" class="pa-5" style="margin-top:3%">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">開立場次資訊</h4>
        </v-row>
        <v-row class="mx-2">
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>場次代碼</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examNo"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>考試方式</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-select class="text_field" dense readonly background-color="#F4F8F9" outlined style="-webkit-text-fill-color: #000"
                :items="examMethodList" item-text="title" item-value="valuev" v-model="datasets.exportStatus">
                  <template v-slot:append>
                    <v-icon></v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證日期</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="examDate"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>繳費方式</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="payGroup"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證考場</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="companyInfo"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>系所/部門</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.dept"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證項目</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class1"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證模組</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class2"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證廠商</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class3"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div id="box" class="pa-5 mt-3">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">考試資訊確認</h4>
        </v-row>
        <v-row class="mx-2">
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>場次報名狀況</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
              <v-select class="text_field" dense readonly background-color="#F4F8F9" outlined style="-webkit-text-fill-color: #000"
              :items="applyStatusList" item-text="title" item-value="valuev" v-model="datasets.applyStatus">
                <template v-slot:append>
                  <v-icon></v-icon>
                </template>
              </v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>已報名人數</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.numOfApplicants"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 ml-0 pt14"><span class="start">*</span>報名繳費截止日期</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="deadline"></v-text-field>                
                <h6 class="start text-left">*欲修改日期請洽學會人員</h6>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>團體收據抬頭</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.groupReceiptTitle"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-1 ml-0 pt14" style="line-height:1.2"><span class="start">*</span>是否需使用密碼報名</div>
              </v-col>
              <v-col class="col-5 col-md-4 py-0 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense readonly v-model="datasets.usePasswd">
                  <v-row>
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">是</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="0" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">否</span>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>
              </v-col>
              <v-col class="col-5 col-md-4 py-0 pl-n10 pr-4">
                <v-row v-if="datasets.usePasswd == '1'">
                  <div class="text-right mt-2 px-2 pt14">密碼</div>
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined style="width:15px" v-model="datasets.passwd"></v-text-field>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="ma-0 py-1">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>是否開放併考</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense readonly v-model="datasets.allowTestTogether">
                  <v-row>
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">是</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="0" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">否</span>
                      </template>
                    </v-radio>
                    <div class="ma-0 pa-0" @mouseenter="mouseInfor=1" @mouseout="mouseInfor=0">
                      <v-icon style="background:#FFF">mdi-alert-circle-outline</v-icon>
                    </div>
                    <div v-if="mouseInfor==1" class="mt-n2 px-2 border absolute" style="width:220px; height:120px">
                      <h4 class="px-2 pt-3" style="font-size:12pt">是否開放非授課學生併考?</h4>
                      <h4 class="px-2 pb-3" style="font-size:12pt">如不開放，請點選「否」以及建議點選「需使用密碼報名」</h4>
                    </div>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- <qrcode-vue size="160" level="H" class="canvas-qrcode"
              :value="'couponId='+coupon.couponId+'&memberId='+$cookie.get('memberId')" /> -->
            <!-- <qrcode-vue size="160" level="H" class="canvas-qrcode"
              :value="'https://13.114.173.137/Apply/#/fastRegistration?' + 'examNo=' + $Global.encrypt(JSON.stringify(datasets.examNo))" /> -->
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <v-row class="ma-0">
            <v-col class="col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>是否有外籍考生</div>
            </v-col>
            <v-col class="py-0 pt-2 pl-6">
              <v-row class="ma-0">
                <v-radio-group class="ma-0 pa-0" dense readonly v-model="datasets.examBranch">
                  <v-row>
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">是</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="0" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">否</span>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>
                <v-row v-if="datasets.examBranch=='1'" class="my-0 ml-4 pa-0">
                  <v-checkbox v-for="(data, index) in examLimitList" :key = "index" :value = "data.valuev" readonly class="pr-3 pa-0 ma-0" color="#215DA7" v-model="datasets.examLimit">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">{{data.title}}</span>
                    </template>
                  </v-checkbox>
                </v-row>
              </v-row>
            </v-col>
          </v-row>
        </v-row>
      </div>
    </div>

    <div v-show="tab==1" id="router" :style="viewStyle">
      <v-simple-table id="tablebox" fixed-header height="670px" class="pa-3" style="margin: 3% 5.8% 4% 4%">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left"><v-checkbox v-if="datasets.applyStatus != '2'" class="ml-3" color="#215DA7" v-model="examRegSelectAll"></v-checkbox></th>
              <th @click="sort('name')" class="text-left">報考人 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('examMemberType')" class="text-left">報考身份 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('havePay')" class="text-left">報考費用 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('examScore')" class="text-left">成績 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('payStatus')" class="text-left">繳費狀態 <v-icon small>icon-form_sort_off</v-icon></th>
              <th class="text-left">功能</th>
              <th class="text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data,index) in examRegList" :key="index">
              <td style="min-width: 60px"><v-checkbox v-if="!data.selectDisable && datasets.applyStatus != '2'" class="ml-3 my-1 pt-2" color="#215DA7" v-model="examRegSelectList[index]"></v-checkbox></td>
              <td style="min-width: 110px"><h4>{{data.name}}</h4></td>
              <td style="min-width: 120px"><h4>{{$Global.getTypevDescription(memberTypeList,data.examMemberType)}}</h4></td>
              <td style="min-width: 120px"><h4>{{data.havePay}}</h4></td>
              <td style="min-width: 100px"><h4>{{data.examScore}}</h4></td>
              <td style="min-width: 160px"><h4 :style = "[{'color' : (data.payStatus=='3') ? '#000' : (data.payStatus=='4') ? '#000' : '#F00'}]">{{$Global.getTypevDescription(payStatusList,data.payStatus)}}</h4></td>
              <td style="min-width: 80px">
                <v-btn v-if="!data.selectDisable && datasets.applyStatus != '2'" outlined style="height:30px; background:#81C0E2; color:#FFF" @click="$refs.DeleteConfirm.open(2,'','',true), deleteId = data.id"><span style="font-size:14px">刪除</span></v-btn>
              </td>
              <td style="min-width: 80px">
                <v-btn outlined style="height:30px; background:#FFF; color:#979797" @click="redirectPath2('/projectMemberInfo', data.id)"><span style="font-size:14px">編輯</span></v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div v-show="tab==2" id="router" :style="viewStyle">
      <div id="box1" class="pa-0" style="margin-top:3%">
        <v-row class="ma-0">
          <v-col class="pa-0 col-12 col-md-6 mb-2" align="center">
            <v-simple-table id="tablebox" fixed-header height="670px" class="pa-3" style="width:98%">
              <template v-slot:default>
                <thead>
                  <tr>
                    <!-- <th class="text-left px-1"><v-checkbox class="mx-1" color="#215DA7" v-model="examRegPaySelectAll"></v-checkbox></th> -->
                    <th class="text-left px-1 pl-5" @click="sort('name')">報考人 <v-icon small>icon-form_sort_off</v-icon></th>
                    <th class="text-left px-1" @click="sort('examMemberType')">報考身份 <v-icon small>icon-form_sort_off</v-icon></th>
                    <th class="text-left px-1" @click="sort('havePay')">報考費用 <v-icon small>icon-form_sort_off</v-icon></th>
                    <th class="text-left px-1" @click="sort('payStatus')">繳費狀態 <v-icon small>icon-form_sort_off</v-icon></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data,index) in examRegPayList" :key="index">
                    <!-- <td class="px-1" style="min-width: 40px"><v-checkbox class="mx-1 my-1 pt-2" color="#215DA7" v-model="examRegPaySelectList[index]"></v-checkbox></td> -->
                    <td class="px-1 pl-5" style="min-width: 100px"><h4>{{data.name}}</h4></td>
                    <td class="px-1" style="min-width: 100px"><h4>{{$Global.getTypevDescription(memberTypeList,data.examMemberType)}}</h4></td>
                    <td class="px-1" style="min-width: 100px"><h4>{{data.havePay}}</h4></td>
                    <td class="px-1" style="min-width: 100px"><h4>{{$Global.getTypevDescription(payStatusList,data.payStatus)}}</h4></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col class="pa-0 col-12 col-md-6" align="center">
            <div id="box" class="pa-5 ma-0" style="width:98%">
              <v-row class="pb-5">
                <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
                <h4 class="DarkBlue pt-1">考試資訊確認</h4>
              </v-row>
              <v-row>
                <v-col cols="2" class="py-0">
                  <div class="text-right pt-2 pt14">報考場次</div>
                </v-col>
                <v-col cols="9" class="py-0">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examNo"></v-text-field>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col cols="2" class="py-0">
                  <div class="text-right pt-2 pt14">一般報考費用</div>
                </v-col>
                <v-col cols="9" class="py-0">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examFee"></v-text-field>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col cols="2" class="py-0">
                  <div class="text-right pt-2 pt14">申請人數</div>
                </v-col>
                <v-col cols="9" class="py-0">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="totalCount"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2" class="py-0">
                  <div class="text-right pt-2 pt14">總金額</div>
                </v-col>
                <v-col cols="9" class="py-0">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="totalPay"></v-text-field>
                </v-col>
              </v-row>
              <!-- <div v-if="this.datasets.checkStatus != '1'">
                <v-row>
                  <v-col cols="2" class="py-0">
                    <div class="text-right pt-2 pt14">認證折扣代碼</div>
                  </v-col>
                  <v-col cols="9" class="py-0 pt-2 pl-5">
                    <v-radio-group class="ma-0 pa-0" dense v-model="couponHave">
                      <v-row>
                        <v-radio class="pr-2" value="0" color="#215DA7">
                          <template v-slot:label>
                            <span class="pt14" style="color:#000000">無</span>
                          </template>
                        </v-radio>
                        <v-radio class="pr-2" value="1" color="#215DA7">
                          <template v-slot:label>
                            <span class="pt14" style="color:#000000">有</span>
                          </template>
                        </v-radio>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row v-if="couponHave=='1'">
                  <v-col cols="2" class="py-0">
                    <div class="text-right pt-2 pt14"></div>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field class="text_field" dense outlined placeholder="請輸入認證折扣代碼" v-model="datasets.couponNo"
                    :readonly="(couponFix)" :background-color="(couponFix)?'#F4F8F9':'#FFF'"
                    @keyup="datasets.couponNo = datasets.couponNo.replace(/[\u4e00-\u9fa5]/ig,''), datasets.couponNo = $Global.toCDB(datasets.couponNo)"></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-btn outlined style="width:100%; height:40px; background:#81c0e2; border-radius:8px; border:none" @click="checkCouponNo()">
                      <span style="color:#FFFFFF">審核</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="couponHave=='1' && couponFix">
                  <v-col cols="2" class="py-0">
                    <div class="text-right pt-2 pt14">折抵金額</div>
                  </v-col>
                  <v-col cols="9" class="py-0">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.couponPrice"></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="couponHave=='1' && couponFix">
                  <v-col cols="2" class="py-0">
                    <div class="text-right pt-2 pt14">折後金額</div>
                  </v-col>
                  <v-col cols="9" class="py-0">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="totalCouponPay"></v-text-field>
                  </v-col>
                </v-row>
              </div> -->
              <v-row class="py-1">
                <v-col cols="2" class="py-0">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>繳費方式</div>
                </v-col>
                <v-col cols="9" class="py-0 pt-2 pl-5">
                  <v-radio-group class="ma-0 pa-0" dense v-model="payment">
                    <v-row>
                      <v-radio class="pr-2" value="0" color="#215DA7">
                        <template v-slot:label>
                          <span class="pt14" style="color:#000000">信用卡繳款</span>
                        </template>
                      </v-radio>
                      <v-radio class="pr-2" value="1" color="#215DA7">
                        <template v-slot:label>
                          <span class="pt14" style="color:#000000">ATM、銀行郵局臨櫃繳款</span>
                        </template>
                      </v-radio>
                      <!-- <v-radio class="pr-2" value="2" color="#215DA7">
                        <template v-slot:label>
                          <span class="pt14" style="color:#000000">LINE Pay</span>
                        </template>
                      </v-radio>
                      <v-radio class="pr-2" value="3" color="#215DA7">
                        <template v-slot:label>
                        <span class="pt14" style="color:#000000">銀聯卡</span>
                        </template>
                      </v-radio> -->
                    </v-row>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2" class="py-0">
                  <div class="text-right pt-2 pt14">繳費期限</div>
                </v-col>
                <v-col cols="9" class="py-0">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="deadline"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0 pt14" justify="center">
                <h4 v-if="datasets.paymentNo" class="py-3 px-6" style="padding-top:2px; color:#F00">
                  您的ATM、銀行郵局臨櫃繳款帳號：{{datasets.paymentNo}}
                </h4>
              </v-row>
            </div>
            <v-row class="col-10 ma-0 pa-0" justify="center">
              <h4 class="pt-3" style="padding-top:2px; font-size:12px">
                *為因應後續認證考試處理作業，最晚請於考試前10天前往繳費，逾期視同放棄本次報名，系統將予以自動刪除！
              </h4>
              <h4 class="pb-3" style="font-size:12px">
                *請身心障礙、低收入戶、其他(特殊家庭)身份考生掃描或拍照其身心障礙、低收入戶、其他(特殊家庭)證明E-mail 檔案到學會Service電子郵件信箱。
              </h4>
            </v-row>
            <v-row class="col-10 ma-0 pa-0 pt14" justify="center">
              <v-btn @click="e17Date = deadline.substring(0,10).replaceAll('-','');confirmOrder()"
              class="mb-5 col-8 col-sm-5 col-md-8 col-lg-6" outlined style="height:40px; background:#81c0e2; border-radius:8px; border:none">
                <span style="color:#FFFFFF">確認繳費</span>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>

    <div v-show="tab==3" id="router" :style="viewStyle">
      <v-simple-table id="tablebox" fixed-header height="670px" class="pa-3" style="margin: 3% 5.8% 4% 4%">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center pl-10" @click="sort('applyCode')">申請編號 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('name')">中文姓名 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('applyItem')">申請項目 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('applyFee')">申請費用 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('paymentMethod')">繳費方式 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('paymentStatus')">繳費狀態 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('paymentDeadline')">繳費期限 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('deliveryStatus')">證書發送狀態 <v-icon small>icon-form_sort_off</v-icon></th>
              <th>功能</th>
              <!-- <th></th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data,index) in certificateDeliveryList" :key="index">
              <td class="text-center pt-2 pb-1" style="min-width: 100px">
                <v-btn class="text-center" outlined style="height:28px; background:#215DA7; color:#FFF" @click="redirectPath('/applyCertificate', data.id)"><span style="font-size:14px">查看</span></v-btn>
                <h4 class="text-center">{{data.applyCode}}</h4>
              </td>
              <td style="min-width: 110px"><h4 class="content">{{data.name}}</h4></td>
              <td style="min-width: 120px"><h4>{{$Global.getTypevDescription(applyItemList,data.applyItem)}}</h4></td>
              <td style="min-width: 110px"><h4>{{data.applyFee}}元</h4></td>
              <td style="min-width: 110px"><h4>{{paymentMethod[data.paymentMethod]}}</h4></td>
              <td style="min-width: 110px"><h4 :style = "[{'color' : (data.paymentStatus==1) ? '#000' : '#F00'}]">{{(data.paymentStatus=='1') ? '已繳費': (data.paymentStatus=='2') ? '未繳費': ''}}</h4></td>
              <td style="min-width: 120px"><h4>{{data.paymentDeadline}}</h4></td>
              <td style="min-width: 140px"><h4>{{(data.deliveryStatus=='0') ? '申請中': (data.deliveryStatus=='1') ? '已寄出': (data.deliveryStatus=='2') ? '已變更' : (data.deliveryStatus=='3') ? '已退費': (data.deliveryStatus=='4') ? '取消申請': ''}}</h4></td>
              <td style="min-width: 260px" class="text-left">
                <v-btn v-if="data.deliveryStatus == '0' && data.paymentStatus == '2' && (new Date(nowTime) < new Date(data.paymentDeadline + ' 23:59:59')) && ((data.paymentMethod == '0') || (data.paymentMethod == '1' && (!data.paymentNo || data.paymentNo == '請至信箱收信或聯繫學會人員取得繳費帳號')))" outlined style="height:30px; background:#81C0E2; color:#FFF" 
                  @click="e17Date = data.paymentDeadline.replaceAll('-',''); setCertificateDelivery(index)">
                  <!-- @click="e17Date = data.paymentDeadline.replaceAll('-','');createApplyOrder(data.applyCode, data.applyFee, data.paymentMethod, data.idCard)"> -->
                  <v-icon class="pr-1" size="16">mdi-credit-card-plus</v-icon>
                  <span style="font-size:14px">前往繳費</span>
                </v-btn>
                <h4 v-if="data.paymentMethod == '1' && data.paymentNo && data.paymentNo != '請至信箱收信或聯繫學會人員取得繳費帳號'">ATM繳費帳號: {{data.paymentNo}}</h4>
                <h4 v-if="data.paymentStatus=='1' && data.deliveryStatus=='4'" style="color:#F00">請主動來信至service@cerps.org.tw</h4>
                <h4 v-if="data.paymentStatus=='1' && data.deliveryStatus=='4'" style="color:#F00">索取退款申請書(須支付行政處理費)</h4>
                <!-- <v-btn v-if="data.receiptPrintCount=='2' && data.deliveryStatus != '3' && data.deliveryStatus != '4'" outlined style="height:30px; background:#81C0E2; color:#FFF" 
                  @click="setCertificateDelivery(index)">
                  <v-icon class="pr-1" size="16">mdi-cloud-print-outline</v-icon>
                  <span style="font-size:14px">下載證書申請收據</span>
                </v-btn> -->
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <!--信用卡繳款-->
    <div style="display:none" v-if="expectPaymentMethod.includes('0')" >
    <INPUT TYPE="TEXT" NAME="Type" value="Auth"></INPUT>
    <v-text-field TYPE="TEXT" NAME="storeid" v-model="hiTrustStoreList[0].storeid"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="ordernumber" v-model="mOrderNumber"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="amount" v-model="mOrderFee"></v-text-field>
    <INPUT TYPE="TEXT" NAME="orderdesc" value="認證鑑定費用"></INPUT>
    <INPUT TYPE="TEXT" NAME="depositflag" value="1"></INPUT>
    <INPUT TYPE="TEXT" NAME="queryflag" value="1"></INPUT>
    <INPUT TYPE="TEXT" NAME="pan" value=""></INPUT>
    <INPUT TYPE="TEXT" NAME="expiry" value=""></INPUT>
    <INPUT TYPE="TEXT" NAME="e01" value=""></INPUT>
    <v-text-field TYPE="TEXT" NAME="returnURL" v-model="hiTrustServiceList[1].url"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="merUpdateURL" v-model="hiTrustServiceList[2].url"></v-text-field>
    <button ref="submit" >Submit</button>
    <INPUT TYPE="SUBMIT" VALUE="執行" >AAA</INPUT>
    </div>
    
    <!--虛擬帳號-->
    <div style="display:none" v-if="expectPaymentMethod.includes('1')" >
    <INPUT TYPE="TEXT" NAME="Type" value="VIRTUAL"></INPUT>
    <v-text-field TYPE="TEXT" NAME="storeid" v-model="hiTrustStoreList[1].storeid"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="ordernumber" v-model="mOrderNumber"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="amount" v-model="mOrderFee"></v-text-field>
    <INPUT TYPE="TEXT" NAME="orderdesc" value="認證鑑定費用"></INPUT>
    <INPUT TYPE="TEXT" NAME="queryflag" value="1"></INPUT>
    <v-text-field TYPE="TEXT" NAME="e17" v-model="e17Date"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="returnURL" v-model="hiTrustServiceList[1].url"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="merUpdateURL" v-model="hiTrustServiceList[2].url"></v-text-field>
    <button ref="submit" >Submit</button>
    <INPUT TYPE="SUBMIT" VALUE="執行" >AAA</INPUT>
    </div>
    
    <!--LINE Pay-->
    <div style="display:none" v-if="expectPaymentMethod.includes('2')" >
    <INPUT TYPE="TEXT" NAME="Type" value="Auth"></INPUT>
    <v-text-field TYPE="TEXT" NAME="storeid" v-model="hiTrustStoreList[2].storeid"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="ordernumber" v-model="mOrderNumber"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="amount" v-model="mOrderFee"></v-text-field>
    <INPUT TYPE="TEXT" NAME="orderdesc" value="認證鑑定費用"></INPUT>
    <INPUT TYPE="TEXT" NAME="depositflag" value="1"></INPUT>
    <INPUT TYPE="TEXT" NAME="queryflag" value="1"></INPUT>
    <v-text-field TYPE="TEXT" NAME="returnURL" v-model="hiTrustServiceList[1].url"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="merUpdateURL" v-model="hiTrustServiceList[2].url"></v-text-field>
    <button ref="submit" >Submit</button>
    <INPUT TYPE="SUBMIT" VALUE="執行" >AAA</INPUT>
    </div>
    
    <!--銀聯卡-->
    <div style="display:none" v-if="expectPaymentMethod.includes('3')" >
    <INPUT TYPE="TEXT" NAME="Type" value="UPOP_AUTH"></INPUT>
    <v-text-field TYPE="TEXT" NAME="storeid" v-model="hiTrustStoreList[3].storeid"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="ordernumber" v-model="mOrderNumber"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="amount" v-model="mOrderFee"></v-text-field>
    <INPUT TYPE="TEXT" NAME="orderdesc" value="認證鑑定費用"></INPUT>
    <INPUT TYPE="TEXT" NAME="depositflag" value="1"></INPUT>
    <INPUT TYPE="TEXT" NAME="queryflag" value="1"></INPUT>
    <INPUT TYPE="TEXT" NAME="pan" value=""></INPUT>
    <INPUT TYPE="TEXT" NAME="expiry" value=""></INPUT>
    <INPUT TYPE="TEXT" NAME="e01" value=""></INPUT>
    <v-text-field TYPE="TEXT" NAME="returnURL" v-model="hiTrustServiceList[1].url"></v-text-field>
    <v-text-field TYPE="TEXT" NAME="merUpdateURL" v-model="hiTrustServiceList[2].url"></v-text-field>
    <button ref="submit" >Submit</button>
    <INPUT TYPE="SUBMIT" VALUE="執行">AAA</INPUT>
    </div>
    </FORM>
    <ShowMsg ref="ShowMsg" :onSave="onShowMsg"/>
    <LoadingVideo ref="LoadingVideo"/>
    <ShowConfirm ref="ShowConfirm" :onSave="onShowConfirm"/>
    <DeleteConfirm ref="DeleteConfirm" :onSave="deleteExamRegBatch"/>
    <ProjectPassword ref="ProjectPassword" />
  </div>
</template>

<script>
// import QrcodeVue from 'qrcode.vue'
import ShowMsg from '@/dialogs/ShowMsg'
import LoadingVideo from '@/dialogs/LoadingVideo'
import ShowConfirm from '@/dialogs/ShowConfirm'
import DeleteConfirm from '@/dialogs/DeleteConfirm'
import ProjectPassword from '@/dialogs/ProjectPassword'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';

export default {
  name: 'Project',
  components: {ShowMsg, LoadingVideo, ShowConfirm, DeleteConfirm, ProjectPassword, Loading},
  mounted(){
    this.tab = ((this.$route.query.tab == '1') ? 1 : (this.$route.query.tab == '2') ? 2 : (this.$route.query.tab == '3') ? 3 : 0)
    if(this.tab == 3){
      this.isLoading = true;
    }
    this.$Global.getNowTime().then(res=>{ this.nowTime = res })
    this.$Global.getFrontendAreaList().then(res=>{ this.frontendAreaList = res })
    this.$Global.getExamMethodList().then(res=>{ this.examMethodList = res })
    this.$Global.getApplyItemList().then(res=>{ this.applyItemList = res })
    this.$Global.getApplyStatusList().then(res=>{ this.applyStatusList = res })
    this.$Global.getPayStatusList().then(res=>{ this.payStatusList = res })
    this.$Global.getMemberTypeList().then(res=>{ this.memberTypeList = res })
    this.$Global.getHiTrustStoreList().then(res=>{ this.hiTrustStoreList = res })
    this.$Global.getHiTrustServiceListProject().then(res=>{ this.hiTrustServiceList = res })
    this.$Global.getExamLimitList().then(res=>{ this.examLimitList = res })
    this.getDataset()
  },
  data:() => ({
    paymentMethod:['信用卡繳款','ATM、銀行郵局臨櫃繳款','LINE Pay','銀聯卡'],
    payment:'',
    expectPaymentMethod:'',
    mOrderNumber:'',
    mOrderFee:0,
    datasets: [],
    examRegList: [],
    examRegPayList: [],
    viewStyle:{},
    orderBy:'id',
    direction:'desc',
    tab:0,
    mouseInfor:0,
    isLoading: false,

    list: [],
    statusCheckbox:'',
    examRegSelectAll: false,
    examRegSelectList: [],
    examRegPaySelectAll: false,
    examRegPaySelectList: [],
    certificateDeliveryList: [],
    receiptDownload: false,
    receiptAppendDownload: false,
    frontendAreaList: [],
    examMethodList: [],
    applyItemList: [],
    applyStatusList: [],
    payStatusList: [],
    memberTypeList: [],
    hiTrustStoreList: [],
    hiTrustServiceList: [],
    examLimitList: [],

    companyInfo:'', //合併company + examClassroom
    payGroup:'', //轉換
    examDate:'', //合併examDate + examTime
    examTimeNow:false, //true可以申請紙本證書 false還沒考試
    deadline:'', //合併deadlineDate + deadlineTime
    e17Date:'', //deadlineDate
    deadlineNow:false, //false不能繳費 + true可以繳費
    nowTime:'',
    deleteId:'', // -1: all
    totalPayApply:'',
    browserName:'',
    platform:'',
    // couponHave:'0', //0無優惠券 1有優惠券
    // couponFix:false, //false未綁定 + true已綁定
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "examRegSelectAll":function(){
      for (var i=0; i<this.examRegSelectList.length; i++) {
        if(this.examRegList[i].selectDisable == false){
          this.examRegSelectList[i] = this.examRegSelectAll
          this.$set(this.examRegSelectList, i, this.examRegSelectAll) //trigger
        }
      }
    },
    "examRegPaySelectAll":function(){
      for (var i=0; i<this.examRegPaySelectList.length; i++) {
        this.examRegPaySelectList[i] = this.examRegPaySelectAll
        this.$set(this.examRegPaySelectList, i, this.examRegPaySelectAll) //trigger
      }
    },
    "tab":function(){
      this.orderBy = 'id'
      this.direction = 'desc'
      this.getExamRegList()
      this.examRegSelectAll = false
      this.examRegPaySelectAll = false
      for (var i=0; i<this.examRegSelectList.length; i++) {
        this.examRegSelectList[i] = false
      }
      for (var i=0; i<this.examRegPaySelectList.length; i++) {
        this.examRegPaySelectList[i] = false
      }
    },
    "totalPay":function(){
      this.mOrderFee = this.expectPaymentMethod.includes('1') ? parseInt(this.totalPay) : (parseInt(this.totalPay+'00'))
    },
    // "totalPay":function(){
    //   if(this.couponHave == '0'){
    //     this.mOrderFee = this.expectPaymentMethod.includes('1') ? parseInt(this.totalPay) : (parseInt(this.totalPay+'00'))
    //   }else{
    //     this.mOrderFee = this.expectPaymentMethod.includes('1') ? parseInt(this.totalCouponPay) : (parseInt(this.totalCouponPay+'00'))
    //   }
    // },
    // "totalCouponPay":function(){
    //   if(this.couponHave == '0'){
    //     this.mOrderFee = this.expectPaymentMethod.includes('1') ? parseInt(this.totalPay) : (parseInt(this.totalPay+'00'))
    //   }else{
    //     this.mOrderFee = this.expectPaymentMethod.includes('1') ? parseInt(this.totalCouponPay) : (parseInt(this.totalCouponPay+'00'))
    //   }
    // },
    "totalPayApply":function(){
      console.log('totalPayApply')
      this.mOrderFee = this.expectPaymentMethod.includes('1') ? parseInt(this.totalPayApply) : (parseInt(this.totalPayApply+'00'))
    },
    // "couponHave":function(){
    //   if(this.couponHave == '0'){
    //     this.datasets.couponNo = null
    //     this.datasets.couponPrice = null
    //   }
    //   if(this.couponHave == '1'){
    //     this.datasets.couponNo = ''
    //     this.datasets.couponPrice = ''
    //   }
    // },
  },
  computed: {
    totalCount(){
      let res = 0
      for (var i=0; i<this.examRegPaySelectList.length; i++) {
        if(this.examRegPaySelectList[i]){
          res++
        }
      }
      return res
    },
    // totalCouponPay(){
    //   let res = 0
    //   for (var i=0; i<this.examRegPaySelectList.length; i++) {
    //     if(this.examRegPaySelectList[i]){
    //       res += Number(this.examRegPayList[i].havePay)
    //     }
    //   }
    //   if(this.datasets.checkStatus == '0' && this.datasets.couponPrice){
    //     console.log('[A0]totalCouponPay')
    //     res = res - Number(this.datasets.couponPrice)
    //   }
    //   console.log('[A1]totalCouponPay')
    //   return res
    // },
    totalPay(){
      let res = 0
      for (var i=0; i<this.examRegPaySelectList.length; i++) {
        if(this.examRegPaySelectList[i]){
          res += Number(this.examRegPayList[i].havePay)
        }
      }
      return res
    },
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-128 + 'px'}
    },
    redirectPath(path, deliverId){
      this.$router.push({path: path, query: {
        id: this.$route.query.id,
        tab: this.tab,
        data: this.$Global.encrypt(JSON.stringify({
          class1: this.datasets.class1,
          class2: this.datasets.class2,
          class3: this.datasets.class3,
          examName: this.datasets.examName,
          examNo: this.datasets.examNo,
          gradeStatus: this.datasets.gradeStatus,
          idCard: this.datasets.idCard,
          name: this.datasets.name,
          receiptTitle: this.datasets.groupReceiptTitle,
          sameRcvCert: this.datasets.sameRcvCert,
          rcvCertName: this.datasets.rcvCertName,
          rcvCertCtel: this.datasets.rcvCertCtel,
          receiverCountry: this.datasets.receiverCountry,
          receiverArea: this.datasets.receiverArea,
          receiverAddress: this.datasets.receiverAddress,
        })),
        deliverId: this.$Global.encrypt(JSON.stringify(deliverId)),
      }})
    },
    redirectPath2(path, deliverId){
      this.$router.push({path: path, query: {
        id: this.$route.query.id,
        tab: this.tab,
        applyStatus: this.datasets.applyStatus,
        deliverId: this.$Global.encrypt(JSON.stringify(deliverId)),
      }})
    },
    browserVersion() {
      var UA = navigator.userAgent;
      var tMatch;
      var M = UA.match(/(OPERA|CHROME|SAFARI|FIREFOX|MSIE|TRIDENT(?=\/))\/?\s*(\d+)/i) || [];
      if (/TRIDENT/i.test(M[1])) {
        tMatch = /\brv[ :]+(\d+)/g.exec(UA) || [];
        return "IE " + (tMatch[1] || "");
      }
      if (M[1] === "Chrome") {
        tMatch = UA.match(/\b(OPR|Edg)\/(\d+)/);
        if (tMatch != null) {
          return tMatch.slice(1).join(" ").replace("OPR", "Opera").replace("Edg", "Edge");
        }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((tMatch = UA.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tMatch[1]);
      return M.join(" ");
    },
    confirmOrder(state){
      this.browserName = this.browserVersion()
      this.platform = navigator.platform
      let tmp = this.browserName + ' ' + this.platform

      this.$Global.setSystemLog(
        '5', //ipAddress
        sessionStorage.getItem('cerpsMemberIdCard'), //userId
        'payTime', //type
        this.datasets.examNo, //examNo
        '繳費監測', //logContent
        new Date(this.nowTime), //note1
        new Date(this.datasets.deadlineDate + 'T' + this.datasets.deadlineTime), //note2
        tmp, //note3
      )

      if(!this.deadlineNow){
        this.$refs.ShowMsg.open(0,'繳費期限逾期','請聯繫學會人員。')
        this.$Global.setSystemLog(
          '', //ipAddress
          sessionStorage.getItem('cerpsMemberIdCard'), //userId
          'deadlineNow', //type
          this.datasets.examNo, //examNo
          '繳費期限逾期', //logContent
          new Date(this.nowTime), //note1
          new Date(this.datasets.deadlineDate + 'T' + this.datasets.deadlineTime), //note2
          tmp, //note3
        )
        return
      }
      if(!this.payment || this.payment==''){
        this.$refs.ShowMsg.open(0,'請輸入所有必填','請選擇繳費方式 !')
        return
      }
      //未開通繳費方式
      if(this.payment=='2' || this.payment=='3'){
        this.$refs.ShowMsg.open(0,'繳費方式尚未開啟','請選擇「信用卡繳款」或「ATM、銀行郵局臨櫃繳款」繳費方式，「LINE Pay」及「銀聯卡」繳費方式尚未開啟，感謝您的配合 !')
        this.payment=''
        return
      }
      //
      if(state != 'payType'){
        if((this.datasets.paymentNo || this.datasets.payType=='1') && this.payment=='1'){
          this.$refs.ShowMsg.open(0,'您已產生繳費帳號','請至信箱收信或聯繫學會人員取得繳費帳號，謝謝。')
          return
        }
      }
      if(this.datasets.payType && this.payment != this.datasets.payType){
        this.$refs.ShowConfirm.open(0,'調整繳費方式','您原本選擇' + ((this.datasets.payType=='0') ? '信用卡繳款': (this.datasets.payType=='1') ? 'ATM、銀行郵局臨櫃繳款' : (this.datasets.payType=='2') ? 'LINE Pay': (this.datasets.payType=='3') ? '銀聯卡': '') + '為繳費方式，本次將繳費方式改為' + 
        ((this.payment=='0') ? '信用卡繳款': (this.payment=='1') ? 'ATM、銀行郵局臨櫃繳款' : (this.payment=='2') ? 'LINE Pay': (this.payment=='3') ? '銀聯卡': '') + '。系統將調整您設定的繳費方式，以便進行繳費。', true)
        return
      }
      if(this.totalPay == 0){
        this.$refs.ShowMsg.open(0,'請選擇繳費對象','請點選複選框(checkbox)選擇將要繳費的對象 !')
        return
      }
      if(!this.datasets.payType || this.payment == this.datasets.payType){
        this.setDataset('order')
      }
    },
    createOrder() {
      var self = this
      self.isLoading = true;
      self.expectPaymentMethod = self.payment
      var midString = ''
      /*
      console.log('self.examRegPaySelectList')
      console.log(self.examRegPaySelectList)
      
      console.log('self.examRegList')
      console.log(self.examRegList)
      
      console.log('self.examRegSelectList')
      console.log(self.examRegSelectList)
      
      console.log('self.examRegPayList')
      console.log(self.examRegPayList)
      */
      for (var i=0; i<self.examRegPaySelectList.length; i++){
        self.examRegPayList[i].paymentNo = (self.examRegPayList[i].paymentNo == null || self.examRegPayList[i].paymentNo == '') ? null : self.examRegPayList[i].paymentNo
        if(self.examRegPaySelectList[i] == true) {
          self.examRegPayList[i].isSelected = true
          midString = midString + self.examRegPayList[i].idCard + ','
        }
      }
      //console.log(self.examRegList)
      
      var orderData = {
        'examNo': self.datasets.examNo,
        'orderType': '1',
        'payWay': self.expectPaymentMethod,
        'mid': midString.substring(0,midString.length-1),
        'membersDetail': JSON.stringify(self.examRegPayList),
        'fee': self.totalPay,
        // 'fee': (self.couponHave == '1') ? self.totalCouponPay : self.totalPay,
        'category': 'REG',
        'havePay': '1',
        'group': '1'
      }
      
      //console.log(orderData)
      
      var request = {
        method: 'POST',
        url: '/erpOrder',
        data: this.Qs.stringify(orderData)
      }
      this.$http(request).then(function(response) {
        console.log(response);
        self.mOrderNumber = response.data.data;
      }).catch((error)=>{
        console.log(error);
      }).finally(()=>{
        setTimeout(() => {
          self.isLoading = false
        },5000)
        if (self.mOrderNumber.includes('hitrust')) {
          parent.window.location.replace(self.mOrderNumber);
        } else {
          self.startWI();
        }
      })
    },
    createApplyOrder(mApplyCode, mTotalPay, mPaymentMethod, idCard) {
      var self = this
      self.isLoading = true;
      self.expectPaymentMethod = mPaymentMethod
      // self.mOrderFee = self.expectPaymentMethod.includes('1') ? mTotalPay : (mTotalPay + '00')
      self.mOrderFee = mTotalPay
      self.totalPayApply = mTotalPay
      
      // var orderData = {
      //   'examNo': self.datasets.examNo,
      //   'note': mApplyCode,
      //   'orderType': '1',
      //   'payWay': self.expectPaymentMethod,
      //   'mid': sessionStorage.getItem('cerpsMemberIdCard'),
      //   'membersDetail': '',
      //   'fee': self.expectPaymentMethod.includes('1') ? mTotalPay : (mTotalPay + '00'),
      //   'category': 'APPLY',
      //   'havePay': '1'
      // }
      var orderData = {
        'examNo': self.datasets.examNo, // self.datasets.examNo  mApplyCode
        'note': mApplyCode,
        'orderType': '1',
        'payWay': self.expectPaymentMethod,
        'mid': idCard,
        // 'mid': sessionStorage.getItem('cerpsMemberIdCard'),
        'membersDetail': '',
        'fee': mTotalPay,
        'category': 'APPLY',
        'havePay': '1'
      }

      //console.log(orderData)
      
      var request = {
        method: 'POST',
        url: '/erpOrder',
        data: this.Qs.stringify(orderData)
      }
      this.$http(request).then(function(response) {
        console.log(response);
        self.mOrderNumber = response.data.data;
        self.mOrderFee = self.expectPaymentMethod.includes('1') ? (parseInt(self.totalPayApply+'00')) : (parseInt(self.totalPayApply+'00'))
      }).catch((error)=>{
        console.log(error);
      }).finally(()=>{
        setTimeout(() => {
          self.isLoading = false
        },5000)
        // self.mOrderFee = self.expectPaymentMethod.includes('1') ? parseInt(self.totalPayApply) : (parseInt(self.totalPayApply+'00'))
        //self.mOrderFee = self.expectPaymentMethod.includes('1') ? parseInt(self.totalPayApply) : (parseInt(self.totalPayApply+'00'))
        if (self.mOrderNumber.includes('hitrust')) {
          parent.window.location.replace(self.mOrderNumber);
        } else {
          self.startWI();
        }
      })
    },
    startWI() {
      this.$refs.submit.click();
      /*
      var self = this
      var postData = {
        'Type': 'Auth',
        'storeid': '50934',
        'ordernumber': self.mOrderNumber,
        'amount': self.datasets.examFee,
        'orderdesc': '認證鑑定費用',
        'depositflag': '1',
        'queryflag': '1',
        'pan':'',
        'expiry':'',
        'e01':'',
        'returnURL': 'https://13.114.173.137/Apply/#/registerInformationList',
        'merUpdateURL': 'http://13.114.173.137:8086/common/wiCcRecord'
      }
      var request = {
        method: 'POST',
        url: '/TrustLink/TrxReqForJava',
        data: this.Qs.stringify(postData)
      }
      this.$http(request).then(function(response) {
        console.log(response)
      }).catch(()=>{
      })
      */
    },
    // checkCouponNo(){
    //   if(this.datasets.couponNo.length <= 4 || this.datasets.couponNo.length >= 10){
    //     this.$refs.ShowMsg.open(0,'系統提示','認證折扣代碼不符合規範')
    //     return
    //   }
    //   if(this.datasets.couponPrice){
    //     this.$refs.ShowMsg.open(0,'系統提示','已綁定認證折扣代碼')
    //     return
    //   }

    //   var self = this
    //   var request = {
    //     method: 'GET',
    //     url: '/checkCoupon',
    //     params: {
    //       'couponNo': self.datasets.couponNo,
    //       'examNo': self.datasets.examNo,
    //       'id': self.datasets.id,
    //       'payGroup': '1', // 1-團體繳費 2-個人繳費
    //     },
    //   }
    //   this.$http(request).then(function(response) {
    //     console.log(response)
    //     if(response.data.msg == '成功!'){
    //       self.$refs.ShowMsg.open(0,'系統提示','折抵成功')
    //       self.getDataset()
    //     }else{
    //       self.$refs.ShowMsg.open(0,'系統提示',response.data.msg)
    //     }
    //   }).catch(()=>{
    //     self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7958')
    //   }).finally(()=>{
    //   })
    // },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExam/' + JSON.parse(this.$Global.decrypt(this.$route.query.id)),
        params: {},
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為pjt-7956')
      }).finally(()=>{
        self.getExamRegList()
        self.getCertificateDeliveryList()
        this.payGroup = (self.datasets.payGroup=='1') ? '團體繳費': (self.datasets.payGroup=='2') ? '個人繳費': ''
        if(self.datasets.exportStatus =='4'){
          this.companyInfo = self.datasets.company
        }else{
          this.companyInfo = self.datasets.company + '-' + self.datasets.examClassroom
        }
        this.examDate = self.datasets.examDate + ' ' + self.datasets.examTime
        this.deadline = self.datasets.deadlineDate + ' ' + self.datasets.deadlineTime
        this.payment = (self.datasets.payType) ? self.datasets.payType : ''

        let time = this.datasets.examTime.split('-')
        this.examTimeNow = (new Date(this.nowTime) > new Date(this.datasets.examDate + 'T' +  time[0])) ? true : false
        // console.log('[A]this.deadline: ' + this.deadline)
        this.deadlineNow = (new Date(this.nowTime) < new Date(self.datasets.deadlineDate + 'T' + self.datasets.deadlineTime)) ? true : false
        // console.log('[A]this.deadlineNow: ' + this.deadlineNow)
        if(this.datasets.examLimit){
          this.datasets.examLimit = JSON.parse(this.datasets.examLimit)
        }
        // if(this.datasets.couponNo){
        //   this.couponHave = '1'
        // }else{
        //   this.couponHave = '0'
        // }
        // if(this.datasets.couponPrice && this.datasets.couponPrice.length>0){
        //   this.couponFix = true
        // }else{
        //   this.couponFix = false
        // }
        // setTimeout(() => { this.totalCouponPay }, 1000); //delay
      })
    },
    setDataset(order){
      if(order=='order' || order=='payType'){
        if(this.payment=='1' && (!this.datasets.paymentNo || this.datasets.paymentNo=='')){
          this.datasets.paymentNo = '請至信箱收信或聯繫學會人員取得繳費帳號'
        }
        this.datasets.payType = this.payment
      }

      var self = this
      var request = {
        method: 'PUT',
        url: '/erpExam',
        data: this.Qs.stringify(self.datasets),
      }
      this.$http(request).then(function(response) {
        console.log(response)
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為pjt-7957')
      }).finally(()=>{
        if(order=='payType'){
          self.confirmOrder('payType')
        }
        if(order=='count'){
          self.getDataset()
        }
        if(order=='order'){
          self.isLoading = true;
          self.createOrder()
        }
        // self.getDataset()
      })
    },
    sort(field){
      this.orderBy = field
      this.direction = (this.direction == 'desc') ? 'asc' : 'desc'
      switch(this.tab){
        case 1:
        case 2:
          this.getExamRegList()
          break
        case 3:
          this.getCertificateDeliveryList()
          break
        default:
          break
      }
    },
    getExamRegList(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExamRegListByExamNo',
        params: {
          'limit': 1000,
          'order': self.orderBy,
          'direction': self.direction,
          'examNo': self.datasets.examNo,
          'source': 'superteacher',
        },
      }
      this.$http(request).then(function(response) {
        self.examRegList = response.data.data.data
        for (var i=0; i<self.examRegList.length; i++) {
          if(self.examRegList[i].payStatus=='3' || self.examRegList[i].payStatus=='4'){
            self.$set(self.examRegList[i], 'selectDisable', true)
          }else{
            self.$set(self.examRegList[i], 'selectDisable', false)
          }
        }
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為pjt-7958')
      }).finally(()=>{
        self.examRegSelectList = []
        for (var i=0; i<self.examRegList.length; i++) {
          self.examRegSelectList.push(false)
        }

        let tmp = self.examRegList
        self.examRegPayList = []
        for(var i=0; i<tmp.length; i++) {
          // console.log('[tmp[i].payStatus]: ' +  tmp[i].payStatus)
          // console.log('[tmp[i].payStatus] typeof: ' + typeof(tmp[i].payStatus))
          if(tmp[i].payStatus!='2' && tmp[i].payStatus!='3' && tmp[i].payStatus!='4' && tmp[i].payStatus!='7')
          self.examRegPayList.push(tmp[i])
        }
        if(self.datasets.payGroup=='1'){ //團體繳費才做
          self.examRegPaySelectList = []
          for (var i=0; i<self.examRegPayList.length; i++) {
            self.examRegPaySelectList.push(true)
          }
        }
        for (var i=0; i<self.examRegList.length; i++) {
          if(self.examRegList[i].payStatus == '4'){
            self.receiptDownload = true
            return
          }
        }
      })
    },
    getCertificateDeliveryList(){
      var self = this
      var request = {
        method: 'GET',
        url: '/certificateDeliveryListByApplicantIdCardAndExamNo',
        params: {
          'examNo': self.datasets.examNo,
          'applicantIdCard': sessionStorage.getItem('cerpsMemberIdCard'),
          'limit':1000,
          'order': self.orderBy,
          'direction': self.direction,
        },
      }
      this.$http(request).then(function(response) {
        self.certificateDeliveryList = response.data.data
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為pjt-7959')
      }).finally(()=>{
        for (var i=0; i<self.certificateDeliveryList.length; i++) {
          if(self.certificateDeliveryList[i].paymentStatus == '1'){
            self.receiptAppendDownload = true
            return
          }

          if(self.certificateDeliveryList[i].paymentMethod == '1' && self.certificateDeliveryList[i].paymentNo == '請至信箱收信或聯繫學會人員取得繳費帳號'){
            const promise = JSON.parse(self.certificateDeliveryList[i].orderId)
            for(var j=0; j<promise.length; j++){
              if(promise[j].payWay == '1'){
                self.getCertificateOrdernumber(i,self.certificateDeliveryList[i].paymentMethod,promise[j].orderId)
              }
            }
          }
        }
        self.isLoading = false
      })
    },
    async getCertificateOrdernumber(index,payType,orderId){
      let storeid = this.hiTrustStoreList[payType].storeid
      var self = this
      var request = {
        method: 'POST',
        url: '/TrustLink/QueryOnly?ordernumber=' + orderId + '&storeid=' + storeid + '&type=7' + '&examNo=' + this.datasets.examNo + '&idCard=' + this.datasets.idCard,
        params: {}
      }
      await this.$http(request).then(function(response) {
        if(response.data.data.e21){
          self.certificateDeliveryList[index].paymentNo = response.data.data.e21
        }else{
          self.certificateDeliveryList[index].paymentNo = ''
        }
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Mod-7967')
      }).finally(()=>{
      })
    },
    setCertificateDelivery(index){
      if(this.certificateDeliveryList[index].paymentMethod=='1' && !this.certificateDeliveryList[index].paymentNo){
        this.certificateDeliveryList[index].paymentNo = '請至信箱收信或聯繫學會人員取得繳費帳號'
      }
      var self = this
      var request = {
        method: 'PUT',
        url: '/certificateDeliveryPaymentNoAndPayTypeUpdate',
        data: this.Qs.stringify(self.certificateDeliveryList[index])
      }
      this.$http(request).then(function(response) {
        console.log(response)
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為pjt-7960')
      }).finally(()=>{
        self.createApplyOrder(self.certificateDeliveryList[index].applyCode, self.certificateDeliveryList[index].applyFee, self.certificateDeliveryList[index].paymentMethod, self.certificateDeliveryList[index].idCard)
      })
    },
    deleteExamReg(id){
      var self = this
      var request = {
        method: 'PUT',
        url: '/erpExamRegStatusUpdate/' + id,
        params: {},
      }
      this.$http(request).then(function(response) {
        // console.log(response)
        self.$Global.setSystemLog(
          '', //ipAddress
          sessionStorage.getItem('cerpsMemberIdCard'), //userId
          'deleteExamRegStatusUpdate', //type
          self.datasets.examNo, //examNo
          id, //logContent
          '', //note1
        )
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為pjt-7961')
      }).finally(()=>{
        self.getExamRegList()
        self.$refs.ShowMsg.open(0,'已刪除資料','您已刪除資料 !')
      })
    },
    deleteExamRegBatch(){
      if(this.deleteId != -1){
        this.deleteExamReg(this.deleteId)
      } else { //all
        for(var i=0; i<this.examRegSelectList.length; i++){
          if(this.examRegSelectList[i]){
            let id = this.examRegList[i].id
            console.log("[deleteExamRegBatch] id: " + id)
            this.deleteExamReg(id)
          }
        }
      }
    },
    getReceiptPdf(){
      var self = this
      self.isLoading = true
      var request = {
        method: 'GET',
        url: '/receiptDownloadMerge/exportpdf',
        params: {
          'examNo': self.datasets.examNo,
          'printType': 'member',
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/rar' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets.examNo + '_考生收據.rar')
        link.click()
      }).catch((error)=>{
        alert(error)
      }).finally(function() {
        self.isLoading = false
      });
    },
    getReceiptAppendPdf(){
      var self = this
      self.isLoading = true
      var request = {
        method: 'GET',
        url: '/receiptAppendDownloadMerge/exportpdf',
        params: {
          'examNo': self.datasets.examNo,
          'printType': 'member',
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/rar' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets.examNo + '_證書申請收據.rar')
        link.click()
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為pjt-7962')
      }).finally(function() {
        self.isLoading = false
      });
    },
    getCertificatePdf(){
      var self = this
      self.$refs.LoadingVideo.open()
      var request = {
        method: 'GET',
        url: '/certificateDownloadMerge/exportpdf',
        params: {
          'examNo': this.datasets.examNo,
          'printType': 'member',
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/rar' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets.examNo + '_考生證書.rar')
        link.click()
      }).catch((error)=>{
        alert(error)
      }).finally(function() {
        self.$refs.LoadingVideo.close()
      });
    },
    getDatasetExcel(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExamRegPageExcel',
        params: {
          'examNo': this.datasets.examNo,
          // 'keyword':self.keyword != ''? self.keyword: null, //manufacturer
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'export.xls'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets.examNo + '_場次成績.xls')
        link.click()
      }).catch((error)=>{
        alert(error)
      }).finally(function() {
        self.$Global.setSystemLog(
          '', //ipAddress
          sessionStorage.getItem('cerpsMemberIdCard'), //userId
          'erpExamRegPageExcel', //type
          self.datasets.examNo, //examNo
          '下載場次成績', //logContent
          '', //note1
          '', //note2
          '', //note3
        )
      });
    },
    duplication(){      
      this.$router.push({path: '/projectApplication', query: {
        setCopy: this.$route.query.id,
      }})
      this.$root.$emit('menuName', '認證考試');
      this.$root.$emit('subMenuName', '專案認證申請')
    },
    onShowMsg(){
      this.redirectPath('/projectList')
    },
    onShowConfirm(){
      this.setDataset('payType')
    },
  }
}
</script>

<style>
  @media (max-width: 959px) {
    .menuApp {
      display: unset !important;
    }
    .menuWeb, .menuAppBtn {
      display: none !important;
    }
    .appBtn{
      display: unset !important;
    }
    .webBtn{
      display: none !important;
    }
  }
</style>